import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openDeleteMedia } from '../../actions/mediaDelete';
import { openRenameMedia } from '../../actions/mediaConfig';
import Icon from '../Icon/Icon';

const propTypes = {
  id: PropTypes.number.isRequired,
  thumbnail: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  fileExtension: PropTypes.string.isRequired,
  updatedOn: PropTypes.string,
  resolution: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onUnSelect: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func,
  isSelected: PropTypes.bool,
  original: PropTypes.string,
  openDeleteMedia: PropTypes.func.isRequired,
  openRenameMedia: PropTypes.func.isRequired,
};

const defaultProps = {
  resolution: '',
  updatedOn: '',
  isSelected: false,
  original: '',
  onDoubleClick: () => {},
};

const asDate = (date) => {
  if (isNaN(Date.parse(date))) {
    return '';
  }
  return (new Date(date)).toLocaleDateString();
};

let clickTimeout = null;

const ImageItem = (props) => {
  const {
    fileExtension,
    filename,
    id,
    isSelected,
    original,
    resolution,
    updatedOn,
    thumbnail,
  } = props;

  const onSelect = () => {
    if (props.isSelected) {
      return props.onUnSelect(props.id);
    }

    return props.onSelect(props.id);
  };

  const onRename = (evt) => {
    evt.preventDefault();
    props.openRenameMedia({ id, filename, fileExtension });
  };

  const onDelete = (evt) => {
    evt.preventDefault();
    props.openDeleteMedia({ id, filename, fileExtension });
  };

  const onDoubleClick = () => {
    props.onDoubleClick(props.id);
  };

  const handleClicks = () => {
    if (clickTimeout !== null) {
      clearTimeout(clickTimeout);
      clickTimeout = null;
      onDoubleClick();
    } else {
      onSelect();
      clickTimeout = setTimeout(() => {
        clearTimeout(clickTimeout);
        clickTimeout = null;
      }, 200);
    }
  };

  return (
    <div className="o-bb-media">
      <div
        className="o-bb-media__image"
        onClick={handleClicks}
      >
        <img src={thumbnail} alt="" className="o-bb-media__img" draggable="false" />
        {isSelected && (
          <div className="o-bb-media__active">
            <i className="icon-arrows_check" />
          </div>
        )}
      </div>
      <div className="o-bb-media__footer">
        <h2 className="o-bb-media__title">{filename}{fileExtension}</h2>
        <ul className="o-bb-media__actions">
          <li key="delete">
            <a onClick={onDelete} className="o-action-link">
              <Icon name="trash" className="icon--small" />
            </a>
          </li>
          <li key="rename">
            <a onClick={onRename} className="o-action-link">
              <Icon name="edit" className="icon--small" />
            </a>
          </li>
          <li key="download">
            <a href={original} target="_blank" className="o-action-link">
              <Icon name="download" className="icon--small" />
            </a>
          </li>
        </ul>
        <div className="o-bb-media__meta">
          {asDate(updatedOn)} <span>|</span> {resolution}
        </div>
      </div>
    </div>
  );
};

ImageItem.propTypes = propTypes;
ImageItem.defaultProps = defaultProps;

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  openDeleteMedia,
  openRenameMedia,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImageItem);



// WEBPACK FOOTER //
// ./src/components/MediaManager/ImageItem.js